import { getSetOfPolylines } from '@/frontend/maps/helpers';
import SnapToRoute from '../../../common/prototypes/SnapToRoute';

const milestoneListenerEvent = new Event('milestoneMarkersUpdated');
const loadedMilestonesEvent = new Event('loadedMilestones');
const maxMilestonesEvent = new Event('maxMilestones');

window.milestoneMarkerIncrement = 0;



const milestoneMap = async (dataMilestones) => {
	const missionId = window.missionId;
	const missionDistance = window.missionDistance;
	const distanceUnit = window.distanceUnit;

	const milestoneImageGenURL = '/imagegen/milestones/markers/'+missionId+'/';

	let polylines = [];
	window.map = new google.maps.Map(document.getElementById('map_canvas'), {
        mapTypeId: google.maps.MapTypeId.TERRAIN,
        disableDefaultUI: false,
        disableDoubleClickZoom: true,
        zoomControl: true,
        scrollwheel: true,
        maxZoom: 20,
        minZoom: 3,
        draggableCursor: 'crosshair',
        panControl: false,
        streetViewControl: window.showStreetViewLayer === true,
    });

	if (window.showStreetViewLayer === true) {
		const streetViewLayer = new google.maps.StreetViewCoverageLayer();
		streetViewLayer.setMap(map);
	}

	const bounds = new google.maps.LatLngBounds();

	// Loaded Polyline
	await $.ajax({
		type: 'GET',
		url: '/default/ajax?ajax=get_encoded_polyline',
		data: { 
			mission_id: missionId
		}
	}).done(function( { data } ) {
		const setOfPolylines = getSetOfPolylines(data);

		// First coordinate - display start flag
		const firstCoordinate = setOfPolylines[0].markerLatLng;
		new google.maps.Marker({
			map: map,
			position: firstCoordinate,
			icon: '/public/images/map/flag-start.png'
		});

		// Last coordinate - display last flag
		const [lastPolylineItem] = setOfPolylines.slice(-1);
		const lastCoordinate = lastPolylineItem.markerLatLng;
		new google.maps.Marker({
			map: map,
			position: lastCoordinate,
			icon: '/public/images/map/flag-finish.png'
		});


		setOfPolylines.forEach(({path, style, markerLatLng}) => {
			bounds.extend(markerLatLng);

			if (style === 'visible') {
				const polyline = new google.maps.Polyline({
					map: map,
					strokeColor: '#e53921',
					strokeOpacity: 0.3,
					strokeWeight: 6,
					clickable: true,
					style: style,
					path: path,
				});

				// Only allow click and snap to route on visible polylines
				google.maps.event.addListener(polyline, 'click', addMilestoneMarker);
				polylines.push(polyline);
			} else if (style === 'skipped') {
				new google.maps.Polyline({
					map: map,
					path: path,
					clickable: false,
					strokeColor: '#818181',
					strokeOpacity: 0.3,
					strokeWeight: 4,
					icons: [
						{
							icon: {
								path: 'M 0,-1 0,1',
								strokeOpacity: 1,
							},
							offset: '0',
							repeat: '20px',
						},
					],
					style: style,
				});
			}
		})

		map.fitBounds(bounds);
	});

	/**
	 * Refresh any currently open marker windows with updated content (primarily
	 * the distance and index may have changed). The affected marker is passed across so we can just do that one by finding it in a loop
	 *
	 * @return {[type]}
	 */
	function refreshMarkerWindows(updatedMarkerIdentifier, open=true, fireListener=true) {
		if (fireListener) {
			window.dispatchEvent(milestoneListenerEvent);
		}

		const milestoneMarkers = window.milestoneMarkers;

		/*let milestoneMarker = false;
		let markerIndex = 0;
		for (var i = milestoneMarkers.length - 1; i >= 0; i--) {
			if (milestoneMarkers[i].marker === updatedMarker) {

				milestoneMarker = milestoneMarkers[i].marker;
				markerIndex = i;
				break;
			}
		}*/

		const milestoneMarker = findMilestoneMarker(updatedMarkerIdentifier);

		if (typeof milestoneMarker !== 'undefined' && milestoneMarker !== false) {
			// This is the marker, let's refresh it with updated content
			const distanceInKm = milestoneMarker.marker.get('distance');
			const number = '';
			
			// Update the content
			const milestoneMarkerInfowindowContent = getMilestoneMarkerContent(updatedMarkerIdentifier, distanceInKm, number, milestoneMarker.marker.get('calibrating'));

			milestoneMarker.infowindowOpen = false;

			if (typeof milestoneMarker.infowindow === 'undefined') {
				milestoneMarker.infowindow = new google.maps.InfoWindow({
				    content: milestoneMarkerInfowindowContent
				});

				milestoneMarker.infowindowListener = google.maps.event.addListener(milestoneMarker.infowindow, 'closeclick', function() {
					milestoneMarker.infowindowOpen = false;
				});
			}
			else {
				milestoneMarker.infowindow.setContent(milestoneMarkerInfowindowContent);
			}

			if (open) {
				if (!milestoneMarker.infowindowOpen) {
					milestoneMarker.infowindow.open(map, milestoneMarker.marker);
				}

				milestoneMarker.infowindowOpen = true;	
			}
		}
	}

	function toMiles(km) {
		var tdis = parseFloat(km) * 0.621371;
		return tdis.toFixed(1);
	}

	function getMilestoneMarkerContent(markerIdentifier, distanceInKm, number, calibrating=false) {
		let contentString = '';

		/*if (Number.isNaN(distanceInKm)) {
			distanceInKm = 0;
		}*/
		let distance = (distanceInKm / 1000).toFixed(1);

		let percentThrough = ((distance / missionDistance) * 100).toFixed(1);
		let percentDisplay = percentThrough + '%';

		if (distanceUnit == 'mi') {
			distance = toMiles(distance);
		}

		let distanceDisplay = distance + ' ' + distanceUnit;

		if (calibrating) {
			contentString = 
				'<div className="text-center">' +
				'<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span><br /><p className="mt-2">Drag the marker<br />and release to<br />set the milestone</p>' +
				'</div>';
		}
		else {
		 	contentString = 
				'<div className="text-center">' +
				'<h2 className="fs-6 mb-2">' + numberWithCommas(distanceDisplay) +'</h2>' +
				'<p>' + numberWithCommas(percentDisplay) + '</p>' +
				'<button className="btn btn-primary" style="margin: 0;font-size:12px;line-height:20px;" onclick="javascript:removeMilestoneMarker('+markerIdentifier+')">Delete</button>' +
				'</div>';
		}

		return contentString;
	}

	function reopenInfowindow(markerIdentifier) {
		const milestoneMarker = findMilestoneMarker(markerIdentifier);

		if (milestoneMarker) {
			if (!milestoneMarker.infowindowOpen) {
				return milestoneMarker.infowindow.open(map, milestoneMarker.marker);
			}
		}
	}

	function init(milestones) {
		if (typeof milestones !== 'undefined' && milestones !== null) {
			for (var i = milestones.length - 1; i >= 0; i--) {
				let milestone = milestones[i];

				addInitMilestoneMarker(milestone, i);
			}
		}

		window.dispatchEvent(loadedMilestonesEvent);
		window.dispatchEvent(milestoneListenerEvent);
	}

	function addInitMilestoneMarker(milestone, i) {
		const identifier = window.milestoneMarkerIncrement += 1;

		let markerIcon = {
			size: new google.maps.Size(44, 160),
		    // The origin for this image is (0, 0).
		    origin: new google.maps.Point(0, 0),
			url: milestoneImageGenURL + (i+1) +'.png',
			anchor: new google.maps.Point(22, 80)
		};

		const milestoneMarker = new google.maps.Marker({
			position: { lat: parseFloat(milestone.lat), lng: parseFloat(milestone.lng) },
			map: map,
			draggable: true,
			icon: markerIcon
		});

		let milestoneMarkerObject = { id: identifier, marker: milestoneMarker, title: milestone.title, description: milestone.description, dbId: milestone.id }

		if (typeof milestone.image !== 'undefined') {
			milestoneMarkerObject.image = { path: milestone.image.path };
		}

		window.milestoneMarkers.push( milestoneMarkerObject );

		const snapToRoute = new SnapToRoute(map, milestoneMarker, polylines, (openInfowindow, fireListener) => refreshMarkerWindows(identifier, openInfowindow, fireListener), false, false);

		milestoneMarker.markerOpenListener = google.maps.event.addListener(milestoneMarker, 'click', () => reopenInfowindow(identifier));
	}

	function addMilestoneMarker(event) {
		if (window.milestoneMarkers.length >= 150) {
			window.dispatchEvent(maxMilestonesEvent);

			return false;
		}
		const identifier = window.milestoneMarkerIncrement += 1;

		const milestoneMarker = new google.maps.Marker({
			position: event.latLng,
			map: map,
			draggable: true
		});

		window.milestoneMarkers.push( { id: identifier, marker: milestoneMarker, title: "", description: "", dbId: "new" } );

		const snapToRoute = new SnapToRoute(map, milestoneMarker, polylines, (openInfowindow, fireListener=true) => refreshMarkerWindows(identifier, true, fireListener));

		window.dispatchEvent(milestoneListenerEvent);

		milestoneMarker.markerOpenListener = google.maps.event.addListener(milestoneMarker, 'click', () => reopenInfowindow(identifier));
	}

	google.maps.event.addListenerOnce(map, 'tilesloaded', () => setTimeout(() => init(dataMilestones),2200));
}

function numberWithCommas(x) {
	return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function findMilestoneMarker(markerIdentifier, returnIndex=false) {
	const milestoneMarkers = window.milestoneMarkers;
	
	let milestoneMarker = false;
	let markerIndex = 0;
	for (var i = milestoneMarkers.length - 1; i >= 0; i--) {
		if (milestoneMarkers[i].id === markerIdentifier) {
			milestoneMarker = milestoneMarkers[i];
			markerIndex = i;
			break;
		}
	}

	if (milestoneMarker !== false) {
		if (returnIndex) {
			return [milestoneMarker, markerIndex];
		}
		else {
			return milestoneMarker;
		}
	}
}

window.removeMilestoneMarker = function(markerIdentifier) {
	const [milestoneMarker, markerIndex] = findMilestoneMarker(markerIdentifier, true);

	milestoneMarker.marker.setMap(null);
	window.milestoneMarkers.splice(markerIndex, 1);

	google.maps.event.removeListener(milestoneMarker.infowindowListener);
	google.maps.event.removeListener(milestoneMarker.markerOpenListener);
	/*

	const thisMarker = window.milestoneMarkers[markerIndex];

	thisMarker.marker.setMap(null);

	window.milestoneMarkers.splice(markerIndex, 1);	*/

	window.dispatchEvent(milestoneListenerEvent);
}

export default milestoneMap